export const getSecurityContext = state => (
  state.securityContext
);

export const getOfflineState = state => (
  state.appState.offline
);

export const getSideBar = state => (
  state.sideBar
);

export const getConfirmModal = state => (
  state.confirmModal
);



// WEBPACK FOOTER //
// ./book/src/commons/selectors/selectors.js